
import { Box, Typography, Alert, CircularProgress, Snackbar } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useAuthorizedReportersData } from './useAuthorizedReportersData';
import AddEmailRow from './AddEmailRow';
import AvatarRowView from './AvatarRowView';

const AuthorizedReporters = () => {
  const { email: authEmail } = useAuth();
  const agencyDomain = authEmail ? (authEmail.split('@')[1]?.toLowerCase() ?? null) : null;
  const data = useAuthorizedReportersData();

  if (data.loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom>Authorized Reporters</Typography>
        <Typography variant="body2" color="text.secondary">
          Reporters listed here can log in and submit worksheets on behalf of your agency.
        </Typography>
      </Box>

      {data.error && (
        <Alert severity="error" sx={{ mb: 2 }}>{data.error}</Alert>
      )}

      <Box sx={{
        bgcolor: data.emails.length > 0 ? 'transparent' : 'grey.50',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 1,
        p: data.emails.length > 0 ? 0 : 1,
        overflow: 'hidden',
        opacity: data.mutating ? 0.5 : 1,
        pointerEvents: data.mutating ? 'none' : 'auto',
        transition: 'opacity 0.15s',
      }}>
        <AvatarRowView emails={data.emails} onRemove={data.handleRemove} />
      </Box>

      <AddEmailRow
        addEmail={data.addEmail}
        setAddEmail={data.setAddEmail}
        addLoading={data.addLoading}
        addError={data.addError}
        addWarning={data.addWarning}
        agencyDomain={agencyDomain}
        onAdd={data.handleAdd}
      />

      <Snackbar
        open={!!data.snackbar}
        autoHideDuration={3000}
        onClose={() => data.setSnackbar(null)}
        message={data.snackbar}
      />
    </Box>
  );
};

export default AuthorizedReporters;
